/** Empty answers are removed from the state instead of being stored. */
export const isEmptyAnswer = (value: unknown): boolean => {
  if (value === undefined || value === null || value === '' || value === false) return true;
  if (Array.isArray(value)) return !value.length;
  if (typeof value === 'object') return !Object.keys(value).length;
  return false;
};

export const normalizeAnswer = (value: unknown): unknown =>
  typeof value === 'string' ? value.trim() : value;
